import { GlobalStyles } from "@mui/material";

/**
 * The global grid theme forces `white-space: normal !important` and centres every cell, so a
 * long value wraps out of a fixed row height and text reads as if it were a number. Grids add
 * these classes to their columns and render the styles once.
 */
export const ONE_LINE_CELL_CLASS = "dxt-one-line";
export const TEXT_CELL_CLASS = "dxt-cell-text";
export const NUMBER_CELL_CLASS = "dxt-cell-number";
export const HEADER_PAD_CLASS = "dxt-header-pad";
/** With NUMBER_CELL_CLASS: keeps right-aligned numbers off the column edge in list grids. */
export const NUMBER_CELL_ROOMY_CLASS = "dxt-cell-number-roomy";
/**
 * Row class of the master list grids (28 px rows). Their plain cells hold the value as bare text,
 * which the `.ag-cell-value` rule above never reaches, so a long centred value was clipped on both
 * sides; here it reads from the start and ends in an ellipsis.
 */
export const LIST_ROW_CLASS = "dxt-list-row";

export const OneLineCellStyles = () => (
	<GlobalStyles
		styles={{
			[`.ag-cell.${ONE_LINE_CELL_CLASS}`]: {
				whiteSpace: "nowrap !important",
				overflow: "hidden",
			},
			[`.ag-cell.${ONE_LINE_CELL_CLASS} .ag-cell-value`]: {
				maxWidth: "100%",
				overflow: "hidden",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap",
			},
			[`.ag-header-cell.${HEADER_PAD_CLASS}`]: {
				padding: "0 4px !important",
			},
			[`.ag-cell.${TEXT_CELL_CLASS}`]: {
				justifyContent: "flex-start !important",
				textAlign: "left !important",
				paddingLeft: "6px !important",
			},
			[`.ag-cell.${NUMBER_CELL_CLASS}`]: {
				justifyContent: "flex-end !important",
				textAlign: "right !important",
				paddingRight: "6px !important",
				fontVariantNumeric: "tabular-nums",
			},
			[`.ag-cell.${NUMBER_CELL_CLASS}.${NUMBER_CELL_ROOMY_CLASS}`]: {
				paddingRight: "12px !important",
			},
			[`.ag-row.${LIST_ROW_CLASS} .ag-cell.ag-cell-value`]: {
				display: "block !important",
				overflow: "hidden",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap !important",
				lineHeight: "27px !important",
			},
		}}
	/>
);
